import { render, staticRenderFns } from "./theFooter.vue?vue&type=template&id=f6de7fd8&scoped=true"
import script from "./theFooter.vue?vue&type=script&lang=js"
export * from "./theFooter.vue?vue&type=script&lang=js"
import style0 from "./theFooter.vue?vue&type=style&index=0&id=f6de7fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6de7fd8",
  null
  
)

export default component.exports